module.exports = "<p-growl [life]=\"10000\"></p-growl>"


//////////////////
// WEBPACK FOOTER
// ./src/app/messages/messages.component.html
// module id = ./src/app/messages/messages.component.html
// module chunks = main